import {dispatch} from 'od-modules/secure_store/store';
import {
    SET_SHOPPING_CART,
} from 'od-modules/secure_store/actions';

export default {
    getUrl() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')('get-shopping-cart');
    },
    getMethod() {
        return 'GET';
    },
    requestSuccess(response) {
        if (response !== null) {
            dispatch({type: SET_SHOPPING_CART, entry: response});
        }
        return response;
    },

    requestError(response) {
        return response;
    },
};
